import * as React from 'react';
import { PageLayout } from '../../../components/Layout';
import { HeroContainer, StickyFooterContainer } from '../Hero';
import { FAQContainer } from '../../common/FAQ';
import { ProfiContainer } from '../../common/Profi';
import { HowItWorkContainer } from '../../common/HowItWork';
import { AboutSdelka } from '../../common/AboutSdelka';
import { WhyNeedSdelkaContainer } from '../WhyNeedSdelka';
import { BannerFormContainer } from '../Form';

export const PageContainer: React.FC = () => {
  return (
    <>
      <HeroContainer />

      <PageLayout>
        <AboutSdelka />
        <WhyNeedSdelkaContainer />
        <HowItWorkContainer />
        <ProfiContainer />
        <BannerFormContainer />
        <FAQContainer />
      </PageLayout>

      <StickyFooterContainer />
    </>
  );
};
